<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div
  fxLayout="column"
  fxLayoutAlign="space-around start"
  class="nvc-profile-div-style"
  *ngIf="
    !(
      coverImage ||
      boardImage ||
      isAudio ||
      ispdf ||
      paymentDump ||
      productCreation ||
      isQuote ||
      bUnit ||
      wallImage ||
      floorImage
    )
  "
>
  <mat-card [matMenuTriggerFor]="menu" class="nvc-profile-image-style">
    <!-- <img
    alt="image"
    [src]="previewProfileImageUrl"
    [ngClass]="
      editMode ? 'nvc-profile-image-style' : 'nvc-profile-image-non-edit'
    "
  /> -->
    <!-- <img [src]="qrCode" class="nvc-image-style" (click)="showQr_code(qrCode)" *ngIf = "qrCode && !editMode"> -->
    <div *ngIf="editMode">
      <div class="nvc-bottom nvc-size">
        <img
          src="assets/icons/file-upload-image.svg"
          class="nvc-edit-icon-style"
        />
        (450 x 600)
      </div>
      <!-- <mat-icon
      [matMenuTriggerFor]="menu"
      class="fa fa-pencil nvc-edit-icon-style"
    ></mat-icon> -->
    </div>
    <div class="nvc-size-9">
      Profile Image <br />
      (JPEG, JPG, PNG)
    </div>
  </mat-card>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="startCamera()" i18n class="notranslate">
      Take Photo
    </button>
    <button mat-menu-item (click)="upload.click()" i18n class="notranslate">
      Upload Photo
    </button>
    <!-- <button
      mat-menu-item
      [hidden] = "true"
      (click)="deleteProfileImage()"
      *ngIf="
        previewProfileImageUrl !== defaultProfileImage &&
        (flag || previewProfileImageUrl.indexOf('default.png') === -1)
      "
      i18n
      class="notranslate"
    >
      Delete Photo
    </button> -->
  </mat-menu>
</div>
<div
  fxLayout="column"
  fxLayoutAlign="space-around start"
  [ngClass]="{ 'nvc-profile-div-style': !fromTemplates }"
  *ngIf="coverImage && !boardImage && !isAudio && !ispdf"
>
  <mat-card class="nvc-cover-image-style" (click)="cover.click()">
    <div>
      <div *ngIf="!fromTemplates" class="nvc-card-heading">Upload Image</div>
      <div *ngIf="fromTemplates" class="nvc-card-heading">Upload Logo</div>
      <div class="nvc-card-subhead">PNG, JPG and Jpeg are allowed</div>
      <div>
        <img src="assets/icons/file-upload-image.svg" class="nvc-image-cover" />
      </div>
    </div>
  </mat-card>
</div>
<div *ngIf="isQuote">
  <div
    fxLayout="row"
    fxLayoutGap="1em"
    class="sc-border-bottom"
    (click)="upload.click()"
  >
    <div fxFlex="25" fxLayoutAlign="center center">
      <img src="assets/icons/grey-upload.svg" class="sc-upload-img" />
    </div>
    <!-- assets/icons/file-upload-image.svg -->
    <div class="sc-sub-descriptions" fxFlex="60" fxLayoutAlign="start center">
      Upload documents
    </div>
    <div fxFlex="15" fxLayoutAlign="center center">
      <span class="material-icons sc-color-primary"> add_photo_alternate </span>
    </div>
  </div>
</div>
<div
  fxLayout="column"
  fxLayoutAlign="center center"
  *ngIf="paymentDump || productCreation"
  [ngClass]="itemCreation && !noMedia ? 'sc-item-creation' : ''"
>
  <div
    class="nvc-dump-card"
    *ngIf="!noMedia"
    [ngClass]="{
      'nvc-width-hundred': isMobile,
      'sc-item-creation': itemCreation,
      'sc-card-disabled': currentLimit === '0'
    }"
    (click)="
      itemCreation
        ? isSingle
          ? cover.click()
          : upload.click()
        : paymentLabel.click()
    "
  >
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
      <div class="sc-dump-img-div" fxLayoutAlign="center center">
        <img
          [src]="
            currentLimit === '0'
              ? 'assets/icons/grey-upload.svg'
              : 'assets/icons/file-upload-image.svg'
          "
          class="nvc-image-cover"
        />
      </div>
      <div
        fxLayout="row"
        class="nvc-size"
        [ngClass]="currentLimit === '0' ? 'sc-media-disabled' : ''"
        fxLayoutAlign="center center"
      >
        + Media
      </div>
    </div>
  </div>
  <div *ngIf="noMedia" fxLayout="row" class="ws-cursor-pointer">
    <img
      src="assets/icons/file-upload-image.svg"
      [ngClass]="
        itemCreation
          ? isMobile
            ? 'nvc-small-image-mobile'
            : 'nvc-small-image'
          : 'nvc-image-cover'
      "
      (click)="glbLabel.click()"
    />
  </div>
</div>
<div
  fxLayout="column"
  fxLayoutAlign="start center"
  class="nvc-profile-div-style"
  *ngIf="boardImage && !isAudio && !ispdf"
>
  <div
    (click)="cover.click()"
    fxLayout="column"
    fxLayoutAlign="center center"
    *ngIf="!imageBoardPath"
    class="nvc-cover-image-style-board"
  >
    <div class="nvc-audio-font nvc-text-align-center">{{ titleText }}</div>
    <div class="nvc-mp3-audio-font">PNG, JPG and Jpeg are allowed</div>
    <div>
      <img src="assets/icons/file-upload-image.svg" class="nvc-image-cover" />
    </div>
  </div>
  <div
    *ngIf="imageBoardPath && !isMobileBoard"
    fxLayoutAlign="center center"
    class="sc-hundred"
  >
    <div
      class="ws-style nvc-position-relative"
      fxLayoutAlign="center center"
      fxLayout="row"
      (mouseenter)="imageText = true"
      (mouseleave)="imageText = false"
    >
      <img
        [src]="getImagePath(imageBoardPath)"
        class="ws-image ws-cursor-pointer"
        (click)="cover.click()"
      />
      <img
        src="assets/icons/cancel-red.svg"
        (click)="deleteImage()"
        class="nvc-cancel ws-cursor-pointer"
      />
      <div
        *ngIf="imageText"
        (click)="cover.click()"
        class="nvc-image-font ws-cursor-pointer"
      >
        Change Image
      </div>
    </div>
  </div>
</div>
<div
  fxLayout="column"
  fxLayoutAlign="start center"
  class="nvc-profile-div-style"
  *ngIf="this.wallImage || this.floorImage"
>
  <div
    (click)="cover.click()"
    fxLayout="column"
    fxLayoutAlign="center center"
    class="nvc-cover-image-style-room"
  >
    <div>
      <img src="assets/icons/file-upload-image.svg" class="nvc-image-cover" />
    </div>
    <!-- <div *ngIf="this.wallImage" class="nvc-audio-font">Upload Wall Image</div>
    <div *ngIf="this.floorImage" class="nvc-audio-font">Upload floor Image</div> -->
  </div>
</div>
<div
  *ngIf="isAudio && !ispdf"
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="0.5em"
  class="nvc-input-field-audio"
  [ngClass]="isCollectionBoard ? 'nvc-input-field-audio-collection' : ''"
  (click)="audio.click()"
>
  <div>
    <img class="nvc-upload-icon" src="assets/icons/file.png" />
  </div>
  <div fxLayout="column">
    <div class="nvc-audio-font">Upload audio</div>
    <div class="nvc-mp3-audio-font">MP3 are allowed</div>
  </div>
</div>

<div
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="0.5em"
  class="nvc-input-field-audio"
  *ngIf="ispdf"
  (click)="pdf.click()"
>
  <div>
    <img class="nvc-upload-icon" src="assets/icons/file.png" />
  </div>

  <div fxLayout="column">
    <div class="nvc-audio-font">Upload Document</div>
    <div class="nvc-mp3-audio-font">Pdf are allowed</div>
  </div>
</div>
<div
  fxLayout="column"
  fxLayoutAlign="space-around start"
  *ngIf="bUnit"
  (click)="cover.click()"
>
  <div class="nvc-store-image-style nvc-size">
    <div *ngIf="editMode" fxLayout="row" fxLayoutGap="20px">
      <div class="nvc-bottom" fxLayoutAlign="start center">
        <img
          src="assets/icons/file-upload-image.svg"
          class="nvc-edit-unit-style"
        />
      </div>
      <div fxLayoutAlign="end start">(800 x 600)</div>
    </div>
    <div>
      Store Image <br />
      (JPEG, JPG, PNG)
    </div>
  </div>
</div>

<label for="upload">
  <input
    #upload
    id="upload"
    type="file"
    accept="image/*"
    class="nvc-hide"
    multiple
    (change)="onSelectProfileImage($event)"
  />
</label>
<label for="paymentLabel">
  <input
    #paymentLabel
    id="paymentLabel"
    type="file"
    accept="image/*, .pdf, .xls, .xlsx, .csv, .doc, .docx, .glb"
    class="nvc-hide"
    multiple
    (change)="onSelectProfileImage($event)"
  />
</label>
<label for="glbLabel">
  <input
    #glbLabel
    id="glbLabel"
    type="file"
    accept=".glb"
    class="nvc-hide"
    (change)="onSelectProfileImage($event)"
  />
</label>
<label for="cover">
  <input
    #cover
    id="cover"
    type="file"
    [accept]="fromTemplates ? 'image/png, image/jpg, image/jpeg' : 'image/*'"
    class="nvc-hide"
    (change)="onSelectProfileImage($event)"
  />
</label>

<label for="audio">
  <input
    #audio
    id="audio"
    type="file"
    [accept]="this.fileUploadService.audioFormats"
    class="nvc-hide"
    (change)="onSelectProfileImage($event)"
  />
</label>

<label for="pdf">
  <input
    #pdf
    id="pdf"
    type="file"
    accept=".pdf"
    class="nvc-hide"
    (change)="onSelectProfileImage($event)"
  />
</label>

<div class="nvc-capture-outer-div" *ngIf="captureImage">
  <div class="nvc-capture-inner-div">
    <i
      class="fa fa-times-circle nvc-minus-style"
      aria-hidden="true"
      (click)="closeCapturing()"
    ></i>
    <video #video autoplay class="nvc-capture"></video>
    <img
      *ngIf="!isMobile"
      src="assets/icons/switch-cam.png"
      class="nvc-switch-camera"
      (click)="switchCamera()"
      alt="switch"
    />
    <div class="nvc-capture-div-style">
      <button
        mat-button
        class="nvc-background-blue nvc-color-white"
        (click)="capture()"
      >
        <b i18n class="notranslate">CAPTURE IMAGE</b>
      </button>
      <img
        *ngIf="isMobile"
        src="assets/icons/switch-cam-mobile.png"
        class="nvc-switch-camera"
        (click)="switchCamera()"
        alt="switch"
      />
      <!-- <span *ngIf="isMobile" class="material-icons" (click)="switchCamera()">flip_camera_ios</span> -->
    </div>
    <canvas #canvas class="nvc-canvas-style"></canvas>
  </div>
</div>
